var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-size-5 tw-rounded-full tw-border tw-border-solid tw-border-grey-300",attrs:{"data-color":_vm.color,"data-type":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }